import { render, staticRenderFns } from "./CustomModal.vue?vue&type=template&id=5575e4ce"
import script from "./CustomModal.vue?vue&type=script&lang=js"
export * from "./CustomModal.vue?vue&type=script&lang=js"
import style0 from "./CustomModal.vue?vue&type=style&index=0&id=5575e4ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports